import React from 'react'
import { Button } from '../styles'

export const Pagination = ({ pagination, disabled, onClickPagination }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {pagination.page > 1 && (
        <Button disabled={disabled} color="#e2e2e2" isActive onClick={() => onClickPagination(false)}>
          {'<'}
        </Button>
      )}
      <Button
        color="#e2e2e2"
        isActive
        style={{
          cursor: 'text',
        }}
      >
        {pagination.page}
      </Button>
      {pagination.hasNext && (
        <Button disabled={disabled} color="#e2e2e2" isActive onClick={() => onClickPagination(true)}>
          {'>'}
        </Button>
      )}
    </div>
  )
}
